import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { LoadingOutlined } from "@ant-design/icons";
export const ActivityIndicator = (param)=>{
    let { color , fontSize =24 , indicator  } = param;
    return /*#__PURE__*/ _jsx(LoadingOutlined, {
        style: {
            fontSize,
            color
        },
        spin: true
    });
// return <Spin indicator={indicator} />
};
